import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 1320,
      lg: 1750,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: "Figtree",
    tableBody: {
      fontSize: "12px",
      lineHeight: "15px",
      color: "#000000",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        caption: {
          fontSize: "13px",
          fontWeight: "400",
          lineHeight: "15px",
          letterSpacing: "0.32px",
          color: "#181B25",
        },
        body1: {
          fontSize: "15px",
          fontWeight: "400",
          lineHeight: "18px",
          color: "#181B25",
        },
        body2: {
          fontSize: "11px",
          fontWeight: "400",
          lineHeight: "13px",
          letterSpacing: "0.32px",
          color: "#181B25",
        },
        h5: {
          fontSize: "18px",
          fontWeight: "500",
          lineHeight: "20px",
          letterSpacing: "0.32px",
          color: "#181B25",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Figtree",
          backgroundColor: "#F6F7FB",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "10px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: "#054A8C",
          opacity: 0.9,
          boxShadow: "5px 0px 5px 0px #00000026",
          paddingTop: "84px",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: 21,
          color: "#ffffff",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "15px",
          fontWeight: 700,
          lineHeight: "17px",
          color: "#ffffff",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "10px 10px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          minHeight: 28,
          height: 28,
          fontWeight: 600,
          fontFamily: "Figtree",
          fontSize: "15px",
        },
      },
    },
  },
});

export default theme;
